<template>
    <b-container fluid class="top-padding bottom-padding no-horiz-padding">

        <h2>Ways to Help Handweaving.net</h2>
        <p>
            We are pleased to be able to make this site available to all, and we need your help to keep providing and improving Handweaving.net. Below are some ways you can help. Although the content and site we offer are world-class, we are small and need financial support in order to continue providing and expanding Handweaving.net. Your donations, subscriptions, and store purchases provide the finances needed for this.
        </p>
        <p>
            <b>THANK YOU!</b>
        </p>

        <h3 class='top-padding'>Subscriptions</h3>

        <p>
            We offer
            <router-link to="/subscription">subscriptions</router-link> to help finance Handweaving.net for a low monthly or annual cost. Subscribers get access to full draft features and more.
        </p>
        <p>
            <b-button variant='primary' to="/subscription">Learn More &raquo;</b-button>
        </p>

        <h3 class='top-padding'>Visit the Handweaving.net Store</h3>

        <p>
            <a href="http://store.handweaving.net" target="_blank">
                <img style="float: left" class='right-padding bottom-padding' :src='this.getProductImageUrl("TaleOfTwoTieups.png")' />
            </a>
        </p>

        <p>
            We offer digital downloads of many draft collections and CDs with nearly all of the documents in the Griswold Archive on Weaving, Textiles, Lace, and Related Topics. Our downloads and CDs are easy to use and work with any type of computer. These purchases and donations help us to continue providing and expanding this site for you!
        </p>

        <p>
            <b-button variant='primary' href="http://store.handweaving.net" target="_blank">Visit our Store &raquo;</b-button>
        </p>

        <h3 class='top-padding'>Donations</h3>

        <a target="_blank" href='https://www.paypal.com/biz/fund?id=UKU47T9WECKV4'>
            <img style='float: left' class='right-padding bottom-padding' border='0' :src='this.getProductImageUrl("PaypalDonateButton.png")' />
        </a>

        <p>
            We use donations to help pay our Internet and cloud hosting costs, which are significant each month.
        </p>

        <p>
            <b-button variant='primary' href='https://www.paypal.com/biz/fund?id=UKU47T9WECKV4' target="_blank">Donate Now &raquo;</b-button>
        </p>

        <p style="clear:both">
            Donations may also be mailed to:
        </p>

        <img style='float: left; max-width: 200px' class='right-padding bottom-padding' :src='this.getProductImageUrl("AirmailStamp.png")' />

        <p>
            <b>Handweaving.net</b><br /> P.O. Box 1158<br /> Coupeville, WA&nbsp;&nbsp;98239<br /> U.S.A.
            <br />
        </p>

        <h3 class='top-padding'>Tell Others About Us!</h3>
        <p>
            If you have a blog or a website, please feel free to link to any page within Handweaving.net! Links help others discover our site. Also please consider mentioning us in your guild newsletter and at your meetings, or simply tell a friend about us!
        </p>

        <p class="bottom-padding">
            Below is a sample link to our home page. To create a link to Handweaving.net, just paste this into the html for your own web page or blog. You can change the address and text to link to any of our pages.
        </p>
        <pre style="display:inline-block">&lt;a href="https://www.handweaving.net"&gt;Visit Handweaving.net!&lt;/a&gt;</pre>

        <h3 class='top-padding'>Drafts</h3>
        <p>
            We are always interested in adding more drafts and scans of works on textiles to this site and some excellent sources of these materials for Handweaving.net have come from visitors like you. If you have access to works on textiles, either in the public domain or for which we could obtain permission, please
            <router-link to="/contact">contact us</router-link>! We are especially excited to find old works containing weaving patterns or complete drafts.
        </p>
        <p>
            Library collections and archives can be great sources for old draft books. The next time you visit a public or university library, see if they have old books with weaving patterns that are not yet in our
            <router-link to="/drafts">draft collections</router-link> and let us know if you find anything interesting. We have obtained and digitized some formerly unknown pattern books from libraries, such as
            <router-link to="/collection-drafts/collection/43/Neueste%20praktische%20Lehr-methode%20der%20Weberei%20zum%20Selbstunterricht%20auf%20Hand-%20und%20Maschinenst%C3%BChlen.,%20Ferdinand%20Langewald">Neueste praktische Lehr-methode der Weberei zum Selbstunterricht auf Hand- und Maschinenstühlen</router-link> by Ferdinand Langewald.
        </p>

        <mailChimpSignup/>
    </b-container>

</template>

<script>
import mailChimpSignup from './MailChimpSignup.vue'
import mediaService from '../mixins/mediaService.js'
export default {
    mixins: [mediaService],
    components: {
        mailChimpSignup: mailChimpSignup
    },
    created() {
        this.$store.commit('setPageTitle', 'Ways to Help Us')
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/WaysToHelp.vue